/**
 * List Schema of CargaTemp
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaTemp} from '@/model/resource/CargaTemp'

/* TODO: review generated schema */
export class ListCargaTempSchema extends Schema {
  readonly name = 'ListCargaTemp'

  readonly fieldSet: FieldSet<CargaTemp> = {
    idCargaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
